import { useState, useCallback } from "react";

/**
 * Hook for managing EditPortfolioModal state
 * Handles modal open/close and portfolio selection for editing
 */
export const useEditPortfolioModal = () => {
    const [open, setOpen] = useState(false);
    const [portfolioId, setPortfolioId] = useState<string>("");
    const [portfolioName, setPortfolioName] = useState<string>("");

    const openModal = useCallback((id: string, name: string) => {
        setPortfolioId(id);
        setPortfolioName(name);
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        setPortfolioId("");
        setPortfolioName("");
    }, []);

    return {
        open,
        portfolioId,
        portfolioName,
        openModal,
        closeModal,
    };
};
